import React from 'react';
export var ChatBootstrapperContext = React.createContext(undefined);
export var useBootstrappedChatState = function () {
    var commPanelState = React.useContext(ChatBootstrapperContext);
    if (!commPanelState) {
        throw new Error('Please setup <ChatBootstrapperProvider /> as a parent component, before using useBootstrappedChatState().');
    }
    return commPanelState;
};
//# sourceMappingURL=context.js.map